import { ColDef } from 'ag-grid-community'
import { Button } from '../../../../components/buttons'
import { colorPalette } from '../../../../style/colorPalette'
import ReloadIcon from '../../../../components/icons/ReloadIcon'
import AddRoundedIcon from '@mui/icons-material/AddRounded'
import SaveButtonArea from '../../../../containers/BulkSheetView/components/header/SaveButtonArea'
import FilterButton from '../../../../containers/BulkSheetView/components/header/FilterButton'
import SortButton from '../../../../containers/BulkSheetView/components/header/SortButton'
import { SortedColumnState } from '../../../../model/bulkSheetColumnSortState'
import { intl } from '../../../../../i18n'

type Props = {
  loading: boolean
  onSubmit: () => void
  onReload: () => void
  onClickAddTicketType: () => void
  filteredColumns: ColDef[]
  onDeleteFilteredColumn?: (column: ColDef) => void
  resetFilters: () => void
  sortColumnsState: SortedColumnState[]
  onDeleteSortedColumn?: (column: string | ColDef) => void
  onDeleteSortedAllColumns: () => void
  onChangeSortColumnState?: (
    column: string | ColDef,
    sort: 'asc' | 'desc' | null
  ) => void
}

const TicketTypesHeader = ({
  loading,
  onSubmit,
  onReload,
  onClickAddTicketType,
  filteredColumns,
  onDeleteFilteredColumn,
  resetFilters,
  sortColumnsState,
  onDeleteSortedColumn,
  onDeleteSortedAllColumns,
  onChangeSortColumnState,
}: Props) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        margin: '10px 10px 5px 10px',
        overflowX: 'auto',
        overflowY: 'hidden',
        minHeight: '47px',
      }}
    >
      <SaveButtonArea loading={loading} onSubmit={onSubmit} />
      <Button
        onClick={onReload}
        sx={{
          background: colorPalette.monotone[1],
          border: `1px solid ${colorPalette.monotone[3]}`,
          borderRadius: '50%',
          height: '28px',
          width: '28px',
          marginRight: '10px',
          padding: '5px 8px',
          cursor: 'pointer',
          '&:hover': { background: colorPalette.monotone[1] },
        }}
      >
        <ReloadIcon />
      </Button>
      <FilterButton
        filteredColumns={filteredColumns}
        onDeleteFilteredColumn={onDeleteFilteredColumn}
        resetFilters={resetFilters}
      />
      <SortButton
        onDeleteSortedColumn={onDeleteSortedColumn}
        onDeleteSortedAllColumns={onDeleteSortedAllColumns}
        onChangeSortColumnState={onChangeSortColumnState}
        sortColumnsState={sortColumnsState}
      />
      <Button
        variant="filled"
        colorPattern="skyBlue"
        size="s"
        onClick={onClickAddTicketType}
        style={{ marginLeft: '10px' }}
      >
        <AddRoundedIcon fontSize="small" />
        {intl.formatMessage({
          id: 'ticketType.registration.create.addButton',
        })}
      </Button>
      <div style={{ flex: 1 }} />
    </div>
  )
}

export default TicketTypesHeader
